export * from './full-layout';
export * from './simple-layout';
export * from './tab-layout';



// WEBPACK FOOTER //
// ./src/app/containers/index.ts